export function Catalan({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="0.998em"
      viewBox="0 0 24 23.95"
      {...props}
    >
      <defs>
        <clipPath id="catalan-clip-path-12213">
          <rect
            id="Rectangle_10407"
            data-name="Rectangle 10407"
            width="18"
            height="14"
            rx="2"
            transform="translate(153 694)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g id="Catalan" transform="translate(-150 -689)">
        <rect
          id="Rectangle_6411"
          data-name="Rectangle 6411"
          width="24"
          height="23.95"
          transform="translate(150 689)"
          fill="none"
        />
        <g
          id="Mask_Group_14095"
          data-name="Mask Group 14095"
          clipPath="url(#catalan-clip-path-12213)"
        >
          <g id="Group_14496" data-name="Group 14496">
            <g id="Group_14495" data-name="Group 14495">
              <rect
                id="Rectangle_10409"
                data-name="Rectangle 10409"
                width="18"
                height="1.55"
                transform="translate(153 706.4)"
                fill="#fad509"
              />
              <rect
                id="Rectangle_10415"
                data-name="Rectangle 10415"
                width="18"
                height="1.55"
                transform="translate(153 704.85)"
                fill="#cc0603"
              />
              <rect
                id="Rectangle_10416"
                data-name="Rectangle 10416"
                width="18"
                height="1.55"
                transform="translate(153 703.3)"
                fill="#fad509"
              />
              <rect
                id="Rectangle_10410"
                data-name="Rectangle 10410"
                width="18"
                height="1.55"
                transform="translate(153 701.75)"
                fill="#cc0603"
              />
              <rect
                id="Rectangle_10413"
                data-name="Rectangle 10413"
                width="18"
                height="1.55"
                transform="translate(153 700.2)"
                fill="#fad509"
              />
              <rect
                id="Rectangle_10414"
                data-name="Rectangle 10414"
                width="18"
                height="1.55"
                transform="translate(153 698.65)"
                fill="#cc0603"
              />
              <rect
                id="Rectangle_10412"
                data-name="Rectangle 10412"
                width="18"
                height="1.55"
                transform="translate(153 697.1)"
                fill="#fad509"
              />
              <rect
                id="Rectangle_10411"
                data-name="Rectangle 10411"
                width="18"
                height="1.55"
                transform="translate(153 695.55)"
                fill="#cc0603"
              />
              <rect
                id="Rectangle_10408"
                data-name="Rectangle 10408"
                width="18"
                height="1.55"
                transform="translate(153 694)"
                fill="#fad509"
              />
            </g>
            <path
              id="Polygon_1"
              data-name="Polygon 1"
              d="M7,0l7,8H0Z"
              transform="translate(161 694) rotate(90)"
              fill="#0e47af"
            />
            <path
              id="Polygon_2"
              data-name="Polygon 2"
              d="M2,0l.5,1.488,1.5.04-1.191.96L3.236,4,2,3.106.764,4l.427-1.512L0,1.528l1.5-.04Z"
              transform="translate(154 699)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
